module.exports = __webpack_public_path__ + "files/8708dd1a510b812ceea1ee7fd6fd2633.png";